<div class="time-series-chart fw fh">
  <div class="chart-area fw fh"></div>
  @if (!drillData?.length) {
    <div class="no-data fw fh"
      >
      <span>{{'common.no_data_small' | translate}}.</span>
    </div>
  }
</div>